export default __webpack_public_path__ + "static/media/2418.b5b1e6fd.png";